// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_jlpt_levels_n5_description = /** @type {(inputs: {}) => string} */ () => {
	return `Learn the basics! Master simple phrases, essential kanji, and fundamental grammar to navigate everyday conversations.`
};

const id_jlpt_levels_n5_description = /** @type {(inputs: {}) => string} */ () => {
	return `Pelajari dasar-dasarnya! Kuasai frasa sederhana, kanji penting, dan tata bahasa fundamental untuk menavigasi percakapan sehari-hari.`
};

const ja_jlpt_levels_n5_description = /** @type {(inputs: {}) => string} */ () => {
	return `基礎を学ぼう！簡単なフレーズ、必須の漢字、基本的な文法をマスターして、日常会話をスムーズに進めましょう。`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "id" | "ja" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const jlpt_levels_n5_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.jlpt_levels_n5_description(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("jlpt_levels_n5_description", locale)
	if (locale === "en") return en_jlpt_levels_n5_description(inputs)
	if (locale === "id") return id_jlpt_levels_n5_description(inputs)
	return ja_jlpt_levels_n5_description(inputs)
};
export { jlpt_levels_n5_description as "jlpt_levels.n5.description" }